export default "__VITE_ASSET__ChTC1K9M__"